import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { MailWizz } from '@/models/mailwizz/mailwizz';
import { IFieldDescription } from '@/models/common/field-description';

@Component
export default class EditMailwizzComponent extends Vue {
    @Prop() mailwizz: MailWizz;

    @Emit('change') notifyChange(e: IFieldDescription) {}

    get name(): string { return this.mailwizz.name }
    set name(value) { this.notifyChange({ field: 'name', value }); }

    get publicKey(): string { return this.mailwizz.publicKey }
    set publicKey(value) { this.notifyChange({ field: 'publicKey', value }); }

    get privateKey(): string { return this.mailwizz.privateKey }
    set privateKey(value) { this.notifyChange({ field: 'privateKey', value }); }

    get url(): string { return this.mailwizz.url }
    set url(value) { this.notifyChange({ field: 'url', value }); }
}
